module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_concept_03-93cf4b0eabc22b484621457bcec34c6d.jpg";